import { makeStyles } from '@material-ui/core/styles';

/**
 * Botões de ação nas linhas das tabelas `CollapsibleRowsTable`, alinhados a `/sistema/users`:
 * 32×32, raio 8, ícones 16px, Tooltip no uso.
 */
export const useTableRowActionButtonStyles = makeStyles(() => ({
  actionRow: {
    display: 'flex',
    gap: 6,
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  actionRowCenter: {
    display: 'flex',
    gap: 6,
    justifyContent: 'center',
    alignItems: 'center',
  },
  rowEditBtn: {
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: '#e8f0fe',
    color: '#1a73e8',
    '&:hover': { backgroundColor: '#d2e3fc' },
  },
  rowDeleteBtn: {
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: '#fef2f2',
    color: '#dc2626',
    '&:hover': { backgroundColor: '#fee2e2' },
  },
  /** Ver, relatório, listagem neutra */
  rowViewBtn: {
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: '#f1f5f9',
    color: '#64748b',
    '&:hover': { backgroundColor: '#e2e8f0' },
  },
  /** Rotacionar / regenerar segredo, token, chave */
  rowRotateBtn: {
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: '#fef3c7',
    color: '#b45309',
    '&:hover': { backgroundColor: '#fde68a' },
  },
  /** Revogar acesso / desativar integração (reversível) */
  rowRevokeBtn: {
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: '#fff7ed',
    color: '#ea580c',
    '&:hover': { backgroundColor: '#ffedd5' },
  },
  /** Pagamento / ação primária positiva (ex.: fatura) */
  rowPayBtn: {
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: '#e8f0fe',
    color: '#1a73e8',
    '&:hover': { backgroundColor: '#d2e3fc' },
  },
  /** WhatsApp */
  rowWhatsAppBtn: {
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: '#dcfce7',
    color: '#15803d',
    '&:hover': { backgroundColor: '#bbf7d0' },
  },
  /** Enviar / testar envio */
  rowSendBtn: {
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: '#dcfce7',
    color: '#15803d',
    '&:hover': { backgroundColor: '#bbf7d0' },
  },
  /** Bloquear (contato ativo) */
  rowBlockToggleBtn: {
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: '#fff7ed',
    color: '#ea580c',
    '&:hover': { backgroundColor: '#ffedd5' },
  },
  /** Desbloquear */
  rowUnblockBtn: {
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: '#dcfce7',
    color: '#16a34a',
    '&:hover': { backgroundColor: '#bbf7d0' },
  },
}));
